import request from '../../utils/request'

export function newModel(data) {
  return request({
    url: '/flow/template/newModel',
    method: 'post',
    data: data
  })
}

export function deployment(id) {
  return request({
    url: '/flow/template/deployment',
    method: 'post',
    data: { id: id }
  })
}

export function del(id) {
  return request({
    url: '/flow/template/del',
    method: 'post',
    data: { id: id }
  })
}
